import React from "react";

import { formatNumber } from "../../weight-and-balance.helpers";
import { ROW_GROUP, STRONG_PARAMETERS } from "../../weight-and-balance.consts";
import { NA } from "../weight-and-balance-manifest.constants";

export const TableLine = ({
    item: {
      title,
      weight,
      arm,
      moment,
      group
    },
    unit,
    nextSpacing,
  }) => {
  const value = weight && weight.value;

  let className = '';

  let formattedValue = formatNumber(`${value}`);

  if (nextSpacing) {
    className = 'border-bottom';
  }

  if (group === ROW_GROUP) {
    className += ' row-seat';
  }

  if (STRONG_PARAMETERS.includes(title)) {
    className += ' strong-field';
  }

  if (title === "Fuel Load") {
    formattedValue = formattedValue + " "  + unit;
  }

  return (
    <tr className={className}>
      <td className={className}>{title}</td>
      <td className='text-center'>{formattedValue}</td>
      <td className='text-center'>{arm ? formatNumber(arm) : NA}</td>
      <td className='text-right'>{moment ? formatNumber(moment) : NA}</td>
    </tr>
  );
};
